<template>
  <div>
    <el-card>
      <el-form ref="searchForm" :model="searchForm" :label-width="formLabelWidth">
        <el-row :gutter="20">
          <el-col :sm="24" :md="12" :lg="5">
            <el-form-item label="所属科目" prop="courseId">
              <!-- <el-input type="number" v-model="searchForm.courseId" auto-complete="off"></el-input> -->
              <el-cascader
                clearable
                v-model="courseIds"
                :show-all-levels="false"
                :props="subjectTreeProps"
                placeholder="请输入所属科目"
                :options="subjectTreeList"
                @change="subjectSearchChange"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="5">
            <el-form-item label="商品名称" prop="name">
              <el-input v-model="searchForm.name" placeholder="请输入商品名称" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>

          <el-col :sm="24" :md="12" :lg="10">
            <el-form-item label="时间" prop="createTime">
              <el-date-picker
                v-model="createTime"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions"
                @change="timeChange"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="4">
            <!-- <el-button type="primary" @click="reset" icon="el-icon-refresh">重置</el-button> -->
            <el-button type="primary" @click="pageList" icon="el-icon-search">查询</el-button>
            <a @click="reset" class="mainColor ml">重置</a>
          </el-col>
        </el-row>
        <el-row :gutter="20"></el-row>
        <el-row :gutter="20"></el-row>
      </el-form>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px;">
      <el-table
        ref="multipleTable"
        :data="page.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        border
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-background="rgba(255, 255, 255, 0.8)"
      >
        <el-table-column prop="name" show-overflow-tooltip label="商品" width="300">
          <template slot-scope="row">
            <el-row>
              <el-col :span="8">
                <span>
                  <!-- <img :src="row.row.logo" /> -->
                  <img
                    style="margin-right:10px;"
                    width="100%"
                    height="44px"
                    :src="row.row.logo?row.row.logo:'../../../static/image/noImg.png'"
                  />
                </span>
              </el-col>
              <el-col :span="16">
                <span
                  style="color:rgb(36, 210, 181);margin-left:10px;"
                  v-if="row.row.recommend=='1'"
                >{{"[推荐]"}}</span>
                <span
                  style="color:rgb(36, 210, 181);margin-left:10px;"
                  v-if="row.row.hot=='1'"
                >{{"[热门]"}}</span>
                <span style="color:rgb(77, 148, 255);margin-left:10px;">{{row.row.name}}</span>
                <span style="display:block;margin-left:10px;">
                  <span style="color:red">￥{{row.row.price}}</span>
                  <span
                    style="text-decoration:line-through;color:rgb(162,170,188)"
                  >￥{{row.row.originalPrice}}</span>
                </span>
              </el-col>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="validDay" width="100" label="有效期">
          <template slot-scope="row">{{row.row.validDay}}天</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip width="100" prop="agentPrice" label="开通价">
          <template slot-scope="row">
            <span style="color:red;font-weight:bold">{{row.row.agentPrice}}</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="subjectCourseName" label="所属科目"></el-table-column>
        <el-table-column show-overflow-tooltip prop="sell" label="是否上架">
          <template slot-scope="row">{{row.row.sell=="1"?"上架":"下架"}}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip width="50" prop="goodsItemCount" label="内容"></el-table-column>
        <el-table-column show-overflow-tooltip prop="createTime" label="上架时间"></el-table-column>
        <el-table-column prop label="操作" width="80" align="center">
          <template slot-scope="scope">
            <span class="mainColor" @click="goodsItem(scope.row)">查看内容</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total, prev, pager, next"
        style="margin-top: 20px;text-align: right;"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      tableData: [],
      addgoodsAgentPrice: {},
      subjectTreeList: [], //科目
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children"
      },
      typeList: [],
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      },
      addFormVisible: false,
      editFormVisible: false,
      importFormVisible: false,
      createTime: "",
      courseIds: [],
      searchForm: {
        courseIds: [],
        sell: 1,
        name: "",
        createTimeBegin: "",
        createTimeEnd: ""
      },
      addForm: {
        name: "",
        logo: "",
        recommend: "",
        hot: "",
        sell: "",
        validDay: "",
        tags: "",
        courseId: "",
        postpone: "",
        postponeDay: "",
        sellCount: "",
        price: "",
        originalPrice: "",
        summary: "",
        detail: ""
      },
      addFormRules: {
        name: [
          {
            required: true,
            message: "请输入商品名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 100,
            message: "商品名称长度在1到100个字"
          }
        ],
        logo: [
          {
            required: true,
            message: "请输入图标",
            trigger: "blur"
          },
          {
            min: 1,
            max: 300,
            message: "图标长度在1到300个字"
          }
        ],
        recommend: [
          {
            required: true,
            message: "请输入是否推荐",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "是否推荐格式不正确"
          }
        ],
        hot: [
          {
            required: true,
            message: "请输入是否热门",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "是否热门格式不正确"
          }
        ],
        sell: [
          {
            required: true,
            message: "请输入是否上架",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "是否上架格式不正确"
          }
        ],
        validDay: [
          {
            required: true,
            message: "请输入有效天数",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "有效天数格式不正确"
          }
        ],
        tags: [
          {
            required: true,
            message: "请输入标签",
            trigger: "blur"
          },
          {
            min: 1,
            max: 1000,
            message: "标签长度在1到1000个字"
          }
        ],
        courseId: [
          {
            required: true,
            message: "请输入科目id-第二级分类",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "科目id-第二级分类格式不正确"
          }
        ],
        postpone: [
          {
            required: true,
            message: "请输入是否支持延期",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "是否支持延期格式不正确"
          }
        ],
        postponeDay: [
          {
            required: true,
            message: "请输入延期天数",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "延期天数格式不正确"
          }
        ],
        sellCount: [
          {
            required: true,
            message: "请输入销量",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "销量格式不正确"
          }
        ],
        price: [
          {
            required: true,
            message: "请输入价格",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "价格格式不正确"
          }
        ],
        originalPrice: [
          {
            required: true,
            message: "请输入原始价格",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "原始价格格式不正确"
          }
        ],
        summary: [
          {
            required: true,
            message: "请输入摘要",
            trigger: "blur"
          },
          {
            min: 1,
            max: 1000,
            message: "摘要长度在1到1000个字"
          }
        ],
        detail: [
          {
            required: true,
            message: "请输入详细介绍",
            trigger: "blur"
          },
          {
            min: 1,
            max: 65535,
            message: "详细介绍长度在1到65535个字"
          }
        ]
      },
      loading: false,
      editForm: {
        name: "",
        logo: "",
        recommend: "",
        hot: "",
        sell: "",
        validDay: "",
        tags: "",
        courseId: "",
        postpone: "",
        postponeDay: "",
        price: "",
        originalPrice: "",
        summary: "",
        detail: ""
      },
      editFormRules: {
        name: [
          {
            required: true,
            message: "请输入商品名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 100,
            message: "商品名称长度在1到100个字"
          }
        ],
        logo: [
          {
            required: true,
            message: "请输入图标",
            trigger: "blur"
          },
          {
            min: 1,
            max: 300,
            message: "图标长度在1到300个字"
          }
        ],
        recommend: [
          {
            required: true,
            message: "请输入是否推荐",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "是否推荐格式不正确"
          }
        ],
        hot: [
          {
            required: true,
            message: "请输入是否热门",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "是否热门格式不正确"
          }
        ],
        sell: [
          {
            required: true,
            message: "请输入是否上架",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "是否上架格式不正确"
          }
        ],
        validDay: [
          {
            required: true,
            message: "请输入有效天数",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "有效天数格式不正确"
          }
        ],
        tags: [
          {
            required: true,
            message: "请输入标签",
            trigger: "blur"
          },
          {
            min: 1,
            max: 1000,
            message: "标签长度在1到1000个字"
          }
        ],
        courseId: [
          {
            required: true,
            message: "请输入科目id-第二级分类",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "科目id-第二级分类格式不正确"
          }
        ],
        postpone: [
          {
            required: true,
            message: "请输入是否支持延期",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "是否支持延期格式不正确"
          }
        ],
        postponeDay: [
          {
            required: true,
            message: "请输入延期天数",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "延期天数格式不正确"
          }
        ],
        price: [
          {
            required: true,
            message: "请输入价格",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "价格格式不正确"
          }
        ],
        originalPrice: [
          {
            required: true,
            message: "请输入原始价格",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "原始价格格式不正确"
          }
        ],
        summary: [
          {
            required: true,
            message: "请输入摘要",
            trigger: "blur"
          },
          {
            min: 1,
            max: 1000,
            message: "摘要长度在1到1000个字"
          }
        ],
        detail: [
          {
            required: true,
            message: "请输入详细介绍",
            trigger: "blur"
          },
          {
            min: 1,
            max: 65535,
            message: "详细介绍长度在1到65535个字"
          }
        ]
      },
      importForm: {},
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      ids: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      fileAction: `${process.env.BASE_URL}/goodsInfo/upload`,
      fileList: [],
      loading: true,
      updatePageId: "",
      goodsId: "",
      updatePageGoodsItem: ""
    };
  },
  computed: {
    ...mapGetters(["loginData"]),
    reqData() {
      return this.$store.state.user;
    }
  },
  methods: {
    goodsItem(row) {
      this.updatePageGoodsItem = row.id;
      this.$router.push({
        path: "/goodsItem",
        query: {
          updatePageGoodsItem: this.updatePageGoodsItem
        }
      });
    },
    goodsNumber(row) {
      this.$router.push({
        path: "/goodsNumber",
        query: { goodsId: row }
      });
    },
    getAgentLevelList() {
      this.tableData = [];
      this.api.goodsAgentPrice.getAgentLevelList().then(result => {
        this.tableData = result.data;
        for (let i in result.data) {
          delete this.tableData[i].createTime;
          delete this.tableData[i].enabled;
          delete this.tableData[i].grade;
          delete this.tableData[i].logo;
          delete this.tableData[i].remark;
          delete this.tableData[i].state;
          delete this.tableData[i].updateTime;
        }
      });
    },

    timeChange() {
      if (this.createTime) {
        this.searchForm.createTimeBegin = this.createTime[0];
        this.searchForm.createTimeEnd = this.createTime[1];
      } else {
        this.searchForm.createTimeBegin = "";
        this.searchForm.createTimeEnd = "";
      }
    },
    subjectSearchChange() {
      if (this.courseIds) {
        this.searchForm.courseIds[0] = this.courseIds[2];
      } else {
        this.searchForm.courseIds = [];
      }
    },
    getSubjectTreeList() {
      // 获取课程
      this.api
        .getSubjectCourseTreeList()
        .then(result => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    delete itemss.children;
                  }
                } else {
                  // delete items.children;
                }
              }
            } else {
              // delete item.children;
            }
          }
          this.subjectTreeList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    //获取数据
    getGoodsInfo() {
      this.api.goodsInfo
        .getGoodsInfo({
          id: this.$route.query.updatePage
        })
        .then(result => {
          this.editForm = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    pageList() {
      this.loading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.searchForm.agentId = this.loginData.agentId;
      this.api.goodsInfo
        .pageList(this.searchForm)
        .then(result => {
          this.page.rows = result.data.records;
          for (let i in this.page.rows) {
            this.page.rows[i].tags = this.page.rows[i].tags.split(" ");
          }
          this.page.total = result.data.total;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    addGoodsInfo() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.api.goodsInfo
            .addGoodsInfo(this.addForm)
            .then(result => {
              this.addFormVisible = false;
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateGoodsInfo() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.api.goodsInfo
            .updateGoodsInfo(this.editForm)
            .then(result => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message
                });
                this.editFormVisible = false;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },

    reset() {
      this.$refs.searchForm.resetFields();
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      };
      this.pageList();
    },
    handleSuccess(response, file, fileList, $event) {
      this.importForm = response.data;
    },
    exportExcel() {
      this.loading = true;
      this.api.goodsInfo
        .exportExcel(this.searchForm)
        .then(result => {
          location.href = result.data;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    importData() {
      this.api.goodsInfo
        .importData(this.importForm.rows)
        .then(result => {
          this.$message({
            type: "success",
            message: result.message
          });
          this.pageList();
          this.importFormVisible = false;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  watch: {
    addFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.pageList();
      } else {
      }
    },
    editFormVisible: function(newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.pageList();
      } else {
        this.getGoodsInfo();
      }
    }
  },
  mounted() {
    this.pageList();
    this.getSubjectTreeList();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/goodsInfo/index.vue